module.exports = __webpack_public_path__ + "img/9_no.8d18f5e1.svg";